<template>
  <div>
    <b-container v-if="isLoading" class="text-center d-flex justify-content-center">
      <b-form>
        <br><br><br>
        <h5>loading</h5>
        <br>
        <b-spinner style="color: rgb(109,122,82) !important"
          variant="warning"
        ></b-spinner>
      </b-form>
    </b-container>
    <div v-else>
      <b-row style="height:40vh;margin:0" class="welcome-picture">
        <b-col cols="1" sm="2">
        </b-col>
        <b-col cols="10" sm="8" style="height:100%">
          <div class="language">
            <template>
              <b-dropdown left split text="language" 
                class="language-dropdown-white" 
                toggle-class="toggle-language-white" 
                split-class="split-language-white" 
                style="font-size: 12px;"
              >
                <template #button-content>
                  <img
                    :src="currentLanguageFlag"
                    style="width:28px; height:19px; border-radius:2px;"
                  >
                </template>

                <!-- Dropdown Items -->
                <b-dropdown-item @click="selectLanguage('en')">
                  <img :src="require('@/assets/img/flags/english.png')" style="width: 37px; height: 25px;">
                  English
                </b-dropdown-item>
                <b-dropdown-item @click="selectLanguage('fr')">
                  <img :src="require('@/assets/img/flags/francais.png')" style="width: 37px; height: 25px;">
                  Français (French)
                </b-dropdown-item>
                <b-dropdown-item @click="selectLanguage('de')">
                  <img :src="require('@/assets/img/flags/deutsch.png')" style="width: 37px; height: 25px;">
                  Deutsch (German)
                </b-dropdown-item>
                <b-dropdown-item @click="selectLanguage('es')">
                  <img :src="require('@/assets/img/flags/spanish.png')" style="width: 37px; height: 25px;">
                  Español (Spanish)
                </b-dropdown-item>
                <b-dropdown-item @click="selectLanguage('it')">
                  <img :src="require('@/assets/img/flags/italian.png')" style="width: 37px; height: 25px;">
                  Italiano (Italian)
                </b-dropdown-item>
                <b-dropdown-item @click="selectLanguage('nl')">
                  <img :src="require('@/assets/img/flags/dutch.png')" style="width: 37px; height: 25px;">
                  Nederlands (Dutch)
                </b-dropdown-item>
                <b-dropdown-item @click="selectLanguage('pt')">
                  <img :src="require('@/assets/img/flags/portuguese.png')" style="width: 37px; height: 25px;">
                  Português (Portuguese)
                </b-dropdown-item>
              </b-dropdown>
            </template>
          </div>
          <div class="welcome-overlay">
            <h1 class="main-title"><span style="color: rgb(195,147,130)">WYNE</span>LOVER</h1>
            <!-- <p class="main-subtitle">about us</p> -->
            <p class="main-subtitle">made by wine lovers - for wine lovers</p>
          </div> 
        </b-col>
      </b-row> 
      <b-row>
         <b-col cols="1" sm="2">
        </b-col>
        <b-col cols="10" sm="8">
          <p class="w-title">We are a group of passionate wine lovers.<p>
          <p class="w-text">Our mission is to enhance the digital wine experience in an open, non-commercial way. That’s why we created <b>WyneLover</b>.</p>
          <p class="w-text">In the first phase, we're developing a trilogy of interconnected online applications: WyneMaker, WyneCellar & WyneTaster.</p>
          <b-row>
            <b-col sm="3">
              <p class="w-text text-left"><a style="color: rgb(112,112,112)" href="http://www.wynemaker.com"><b>www.wynemaker.com</b></a></p>
            </b-col>
            <b-col>
              <p class="w-text text-left">For wine producers to share detailed information about their winery and wines.</p>
            </b-col>
          </b-row>
          <b-row>
            <b-col sm="3">
              <p class="w-text text-left"><a style="color: rgb(112,112,112)" href="http://www.wynecellar.com"><b>www.wynecellar.com</b></a></p>
            </b-col>
            <b-col>
              <p class="w-text text-left">For wine lovers to manage and organize their personal wine cellar.</p>
            </b-col>
          </b-row>
          <b-row>
            <b-col sm="3">
              <p class="w-text text-left"><a style="color: rgb(112,112,112)" href="http://www.wynetaster.com"><b>www.wynetaster.com</b></a></p>
            </b-col>
            <b-col>
              <p class="w-text text-left">To organize or participate in wine tasting events and manage your tasting notes.</p>
            </b-col>
          </b-row>
          <p class="w-text">Once the WyneDatabase is sufficiently populated by producers using the WyneMaker app, we aim to share it with the world via an open API — for the benefit of wine lovers, professionals, and developers alike.</p>
          <hr>
          <p class="w-title">How can you help?</p>
          <p class="w-subtitle">Active support.</p>
          <p class="w-text">We’re looking for passionate volunteers with a wide range of skills to help us complete and promote the project:</p> 
          <p class="w-text" style="margin:15px">&#9642; marketing and promotion</p>
          <p class="w-text" style="margin:15px">&#9642; wine knowledge regional or general</p>
          <p class="w-text" style="margin:15px">&#9642; web design skills, ui/ux</p>
          <p class="w-text" style="margin:15px">&#9642; language & communication skills across different countries </p>
          <p class="w-text" style="margin:15px">&#9642; contacts with wine producers, wine producer associations, wine magazines</p>
          <p class="w-text">If you’re excited by the idea of shaping the digital future of wine, and want to join our volunteer team, we’d love to hear from you.</p>
          <p class="w-text">Interested in becoming a <b>WyneBassador</b>?</p>
          <p class="w-text">Send us an email at <b>admin@wynelover.com</b> and tell us how your skills can contribute to this project.</p>
          
          <p class="w-subtitle">Passive support.</p>
          <p class="w-text">We’re committed to keeping this project non-commercial and open. That means we rely entirely on donations. If you like what we’re building and want to support us, please consider clicking the donate button below.</p>
          <hr>
          <b-row>
            <b-col  class="text-left">
              <b-button v-on:click="onBack()" class="w-button-pink">back</b-button>
            </b-col>
            <b-col  class="text-right">
              <b-button v-on:click="onDonate()" class="w-button-green">donate</b-button>
            </b-col>
          </b-row>
          <br>    
        </b-col>
      </b-row>
      <br>  
    </div>
  </div>
</template>

<script>
  export default {
    name: 'WineryWelcome',
     computed : {
      inSession() {
        return this.$store.state.inSession
      },
      currentUserID() {
        return this.$store.state.user_id
      },
      currentUser() {
        return this.$store.state.user
      },
      currentLanguage() {
        return this.$store.state.language
      },
      currentProfilePicture() {
        return this.$store.state.profile_picture
      },
      currentLanguageFlag() {
        const flags = {
          en: require('@/assets/img/flags/english.png'),
          fr: require('@/assets/img/flags/francais.png'),
          de: require('@/assets/img/flags/deutsch.png'),
          es: require('@/assets/img/flags/spanish.png'),
          it: require('@/assets/img/flags/italian.png'),
          nl: require('@/assets/img/flags/dutch.png'),
          pt: require('@/assets/img/flags/portuguese.png')
        }
        return flags[this.currentLanguage] || flags.en
      },             
      previousPage() {
        return this.$store.state.previous_page
      },
    },
    data() {
      return {
        debug: false, 
        isLoading: true,
      }
    }, 
    mounted() {
      this.isLoading = false
    },
    methods: {
      onBack() {
        this.$router.push({path:'/Winery/'+this.previousPage, query: {winery_id:this.$route.query.winery_id }});
        this.$store.commit('setPage',this.previousPage)
      },
      onDonate() {
        window.open('https://www.paypal.com/donate/?hosted_button_id=968LLYKG8YBP6');
      },
      
      async selectLanguage(language) {
        let local_debug = false
        if (local_debug || this.debug) console.log("Login.selectLanguage: START");
        this.language = language
        this.$store.commit('setLanguage',language)

        if (local_debug || this.debug) console.log("Login.selectLanguage: language set to ", language);

        if (local_debug || this.debug) console.log("Login.selectLanguage: STOP");
      }, 

      translate(string) {
        // console.log("TMP string: ", string, " language: ", this.currentLanguage, " translation: ",translate_word(string, this.currentLanguage) )
        return translate_word(string, this.currentLanguage);
      },
    }
  }
</script>

<style>
@import url("../../assets/styles/wynestyle.css");
</style>

<style scoped>
.welcome-picture {
    width:100vw;
    height:auto;
    
    background-image: url("../../assets/img/header.jpg");
    background-repeat: no-repeat;
    background-size: cover;
    background-position: center center;

    position:relative;
}
.welcome-overlay {
  width:100%;
  max-width: none !important; 
  position: relative;
  top: 10vh;
}

.language {
  position: fixed;
  top: 5px;
  left: 5px;
  color: white;
}
</style> 